import Aplicativo from './Aplicativo';

function Mocks(mock: any) {
    Aplicativo(mock);
}

export default Mocks;
